import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PRIMENG_MODULES } from '../../primeng-imports';

@Component({
  selector: 'app-search-component',
  templateUrl: './search-component.component.html',
  styleUrl: './search-component.component.scss',
  standalone:true,
  imports:[...PRIMENG_MODULES]
})
export class SearchComponent {


  @Input() placeHolder: string = '';
  @Input() itemId: any = '';
  @Input() isNotFound: boolean = true;

  @Output() onSearchClick = new EventEmitter();
  // itemId = '';
  @ViewChild('searchItem') searchItem!: ElementRef<HTMLInputElement>;

  onClick() {
    this.onSearchClick.emit(this.itemId)
  }
  ngAfterViewInit() {
    setTimeout(() => this.searchItem.nativeElement.focus(), 0)
  }
  onClose() {
    this.itemId = '';
    this.onClick()
  }
}
